import angular from "angular";

import OrganisationOwnerRequestsModuleRouting from "./organisation-owner-requests.module.routing";

export default angular
  .module("vt-organisation-owner-requests", [])
  .config(OrganisationOwnerRequestsModuleRouting);
